import { HotjarIdentifyDataLayerItem } from '/@/integrations/googletagmanager/models/HotjarIdentifyDataLayerItem';
import { GTMEvent } from '/@/integrations/googletagmanager/constants/GTMEvent';
import { GuidanceStepStage } from '@/modules/guidancestep/enums/GuidanceStepStage';
import { EstateStatus } from '@/modules/estate/constants/EstateStatus';
import { EstateStatusKey } from '@/modules/estate/constants/EstateStatusKey';
import Locale from '/@/modules/user/Enum/Locale';
import { MaritalStatus } from '@/modules/contact/enums/MaritalStatus';
import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import type { AuthUser } from '@/modules/auth/models/AuthUser';
import type { Metric } from '@/modules/metric/models/Metric';
import type { CurrentEstate } from '@/modules/estate/models/CurrentEstate';

export class HotjarIdentifyDataLayerItemBuilder {
  static build(authUser: AuthUser | null): HotjarIdentifyDataLayerItem | undefined {
    if (!authUser) {
      return;
    }

    const currentEstate: CurrentEstate | null = authUser.currentEstate;

    return new HotjarIdentifyDataLayerItem({
      event: GTMEvent.AUTH,
      userId: authUser.id,
      name: authUser.contact.fullName,
      email: authUser.email,
      billingPlan:
        currentEstate?.billing?.billingPlanMapping?.planId ??
        authUser.billing?.billingPlanMapping?.planId ??
        '',
      role: authUser.estateAccount?.roleName ?? authUser.professional?.profession?.name ?? 'User',
      // @ts-ignore
      assignedEstateProfessionals: authUser.currentEstate?.estateProfessionalEmails ?? [],
      daysSinceSignup: authUser.daysSinceSignup,
      daysSinceLastLogin: authUser.daysSinceLastLogin,
      metricData: authUser.metrics?.reduce(
        (acc: Record<string, string>, metric: Metric) => ({
          ...acc,
          ...{ [metric.name]: metric.value }
        }),
        {}
      ),
      estateStatus: authUser.currentEstate
        ? EstateStatus.getByKey(authUser.currentEstate!.status as EstateStatusKey)?.value
        : undefined,
      guidanceStage: authUser.currentEstate
        ? GuidanceStepStage.getByKey(authUser.currentEstate.guidanceStage ?? '')?.value
        : undefined,
      payingCustomer: !!authUser.isPayingCustomer,
      jurisdiction: authUser.currentEstate?.jurisdictionName,
      estateId: authUser.currentEstate?.id,
      estateName: authUser.currentEstate?.contact.fullName,
      product: authUser.currentEstate?.displayProductType,
      referralPartner: authUser.currentEstate?.company?.name,
      language: Locale.getByKey(authUser.locale ?? '')?.value ?? '',
      createdAt: authUser.createdAt,
      daysSinceAccountCreated: authUser.daysSinceAccountCreation,
      city: authUser.currentEstate?.contact.address?.city ?? '',
      country:
        PredefinedCountry.getByKey(authUser.currentEstate?.contact.address?.countryId ?? '')
          ?.name ?? '',
      maritalStatus: MaritalStatus.getByKey(authUser.contact.maritalStatus ?? '')?.value ?? '',
      guidanceRequested: authUser.currentEstate?.guidanceRequested ?? ''
    });
  }
}
